import React from "react";

import { GameConfigs } from "../../lib/globals/GameConfigs";
import useCoefData from "../helpers/useCoefData";
export default function AdditionalSymbol({
  coefs,
  currentBet,
  slice,
  currency,
  text,
}) {
  const [data] = useCoefData(coefs);
  return (
    <div className="additional_symbol_wrapper">
      <div className="additional_symbol_box">
        <div className="content">
          <div className="title" style={{ marginTop: "20px" }}>
            {text[0].title}
          </div>
          <div className="description">{text[0].desc}</div>
        </div>
        <div className="symbol_wrapper">
          <div className="symbol_box additional">
            <div className="symbol">
              <img src={data && data[slice.a].icon} alt="symbol" />
            </div>
            <div className="coefs_wrapper">
              {data &&
                data[slice.a].coef.map(
                  (c, id) =>
                    c !== 0 && (
                      <div key={id} className="coefs">
                        <span>{id + 1}</span>
                        <p>
                          {(currency.length > 1 ? currency + " " : currency) +
                            ((c * currentBet) / 10).toLocaleString(undefined, {
                              minimumFractionDigits:
                                GameConfigs.config.currency_prec,
                              maximumFractionDigits:
                                GameConfigs.config.currency_prec,
                            })}
                        </p>
                      </div>
                    )
                )}
            </div>
          </div>
        </div>
      </div>
      <div className="additional_symbol_box">
        <div className="content">
          <div
            className="title"
            style={{ color: "#CEEE71", marginTop: "20px" }}
          >
            {text[1].title}
          </div>
          <div className="description">{text[1].desc}</div>
        </div>
        <div className="symbol_wrapper">
          <div className="symbol_box additional">
            <div className="symbol">
              <img src={data && data[slice.b].icon} alt="symbol" />
            </div>
            <div className="coefs_wrapper">
              {data &&
                data[slice.b].coef.map(
                  (c, id) =>
                    c !== 0 && (
                      <div key={id} className="coefs">
                        <span>{id + 1}</span>
                        <p>
                          {(currency.length > 1 ? currency + " " : currency) +
                            ((c * currentBet) / 10).toLocaleString(undefined, {
                              minimumFractionDigits:
                                GameConfigs.config.currency_prec,
                              maximumFractionDigits:
                                GameConfigs.config.currency_prec,
                            })}
                        </p>
                      </div>
                    )
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
